var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDark = function SvgArrowDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D0D0D",
    d: "M4.005 5.588a.583.583 0 0 1 .825 0l3.67 3.67 3.672-3.67a.583.583 0 0 1 .824.825l-4.083 4.083a.583.583 0 0 1-.825 0L4.005 6.413a.583.583 0 0 1 0-.825"
  })));
};
export default SvgArrowDark;